import React, { useState } from "react";
import { feature2, feature3 } from '../data/data';
import nfc from "../assets/images/phone/10.png";
import saldos from "../assets/images/phone/2.png";
import recargas from "../assets/images/phone/7.png";
import food from "../assets/images/phone/12.png";
import notifications from "../assets/images/phone/3.png";
import profile from "../assets/images/phone/4.png";

export default function FeaturesTwo() {
  const images = [nfc, saldos, recargas, food, notifications, profile];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="grid lg:grid-cols-12 md:grid-cols-12 grid-cols-1 mt-6 gap-6 items-center">
      <div className="lg:col-span-4 md:col-span-6 lg:order-1 order-2">
        <div className="grid grid-cols-1 gap-6">
          {feature2.map((item, index) => {
            const Icon = item.icon;
            const isActive = activeIndex === index;

            return (
              <div
                key={index}
                onMouseEnter={() => setActiveIndex(index)}
                onClick={() => setActiveIndex(index)}
                className={`group flex duration-300 xl:p-3 cursor-pointer rounded-2xl transition-all ${
                  isActive ? "bg-red-500/10 scale-105" : "hover:bg-slate-800/30"
                }`}
              >
                <div
                  className={`flex md:order-2 order-1 align-middle justify-center items-center size-16 mt-1 rounded-2xl text-2xl shadow-sm duration-300 ${
                    isActive
                      ? "bg-red-500 text-white"
                      : "bg-red-500/5 dark:bg-red-500/10 text-red-500"
                  }`}
                >
                  <Icon className="size-5" />
                </div>

                <div className="flex-1 md:order-1 order-2 md:text-end md:me-4 md:ms-0 ms-4">
                  <h4
                    className={`mb-0 text-lg font-semibold transition-colors duration-300 ${
                      isActive ? "text-red-500" : "text-slate-900 dark:text-white"
                    }`}
                  >
                    {item.title}
                  </h4>

                  <p className="text-slate-400 mt-3">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="lg:col-span-4 md:col-span-12 lg:mx-4 lg:order-2 order-1">
        <img
          key={activeIndex}
          src={images[activeIndex]}
          className="mx-auto max-h-[700px] object-contain transition-all duration-500 ease-in-out"
          alt="Club333 App"
        />
      </div>

      <div className="lg:col-span-4 md:col-span-6 order-3">
        <div className="grid grid-cols-1 gap-6">
          {feature3.map((item, index) => {
            const Icon = item.icon;
            const realIndex = index + feature2.length;
            const isActive = activeIndex === realIndex;

            return (
              <div
                key={index}
                onMouseEnter={() => setActiveIndex(realIndex)}
                onClick={() => setActiveIndex(realIndex)}
                className={`group flex duration-300 xl:p-3 cursor-pointer rounded-2xl transition-all ${
                  isActive ? "bg-red-500/10 scale-105" : "hover:bg-slate-800/30"
                }`}
              >
                <div
                  className={`flex align-middle justify-center items-center size-16 mt-1 rounded-2xl text-2xl shadow-sm duration-300 ${
                    isActive
                      ? "bg-red-500 text-white"
                      : "bg-red-500/5 dark:bg-red-500/10 text-red-500"
                  }`}
                >
                  <Icon className="size-5" />
                </div>

                <div className="flex-1 ms-4">
                  <h4
                    className={`mb-0 text-lg font-semibold transition-colors duration-300 ${
                      isActive ? "text-red-500" : "text-slate-900 dark:text-white"
                    }`}
                  >
                    {item.title}
                  </h4>

                  <p className="text-slate-400 mt-3">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
